import { exists } from 'helpers/exists'
import React, { FC } from 'react'
import { DropDetailsBrandImage as DropDetailsBrandImageAtom } from 'uiComponents/atoms/Drops/DropDetailsBrandImage'

export const DropDetailsBrandImage: FC<{
  brandImage: string | undefined
  headline: string | undefined
  subline: string | undefined
}> = ({ brandImage, headline, subline }) => {
  if (!exists(brandImage) && !exists(headline)) {
    return null
  }

  return (
    <DropDetailsBrandImageAtom
      brandImage={brandImage}
      headline={headline}
      subline={subline}
    />
  )
}
